import { API_ENDPOINTS } from "../config/api/apiCall";
import { PURCHASE_API_ENDPOINTS } from "../config/api/apiCallPurchase";
import { callApi } from "../utils/apiClient";


export const loadVendorEnquiryList = async(payload)=>{
    try {       
        return await callApi(API_ENDPOINTS.VENDOR_ENQUIRY_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const VendorEnquiryCRUD = async (api, payload) => {
    try {       
        return await callApi(api, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error processing vendor enquiry:", error);
        throw error;  // Ensure the error is properly propagated
    }
};

export const loadVendorDetail = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.VENDOR_ENQUIRY_GET_VENDOR_ITEM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading vendor details", error);
        throw error;
    }
}


export const loadVendorIdByDepartment = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.VENDOR_ENQUIRY_GET_DETAIL_BY_DEPARTMENT_ID, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}


export const loadVendorListByEnquiryID = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.VENDOR_RESPONSE_GET_VENDOR_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);

    }
    catch (error) {
        console.error("Error loading shift employee assignment:", error);
        throw error;
    }
}

export const loadVendorQuotationItemDetail = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.VENDOR_RESPONSE_GET_VENDOR_ITEM_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading vendor quotation item details", error);
        throw error;
    }
}

export const loadVendorDetails = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.GETPartyDetails, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading vendor quotation item details", error);
        throw error;
    }
}


export const loadVendorListByType = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.PURCHASE_GET_VENDOR_LIST_BY_TYPE, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading vendor quotation item details", error);
        throw error;
    }
}
export const loadVendorListByTypeDesc = async(payload)=>{
    try {       

        return await callApi(API_ENDPOINTS.PURCHASE_GET_VENDOR_LIST_BY_TYPE_DESC, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error loading vendor quotation item details", error);
        throw error;
    }
}

export const loadVendorQuotationList = async(payload)=>{
    try {       
        return await callApi(API_ENDPOINTS.VENDOR_QUOTATION_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const loadVendorQuoteComparisonList = async(payload)=>{
    try {       
        return await callApi(API_ENDPOINTS.VENDOR_QUOTE_COMPARISON_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}


export const loadVendorEnquiryDetWithPartyList = async(payload)=>{
    try {       
        return await callApi(PURCHASE_API_ENDPOINTS.VENDOR_ENQUIRY_WITH_PARTIES, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const loadVendorEnquiryComparisionList = async(payload)=>{
    try {       
        return await callApi(PURCHASE_API_ENDPOINTS.VENDOR_ENQUIRY_COMPARISION_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const getEnquiryResponseDataByPurchaseId = async(payload)=>{
    try {       
        return await callApi(PURCHASE_API_ENDPOINTS.VENDOR_ENQUIRY_QUOTATION_BY_PURCHASE, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const getEnquiryResponseDataByPurchaseIdNew = async(payload)=>{
    try {       
        return await callApi(PURCHASE_API_ENDPOINTS.VENDOR_ENQUIRY_QUOTATION_BY_PURCHASE_NEW, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const EnquiryResponseComparisonSave = async(payload)=>{
    try {       
        return await callApi(PURCHASE_API_ENDPOINTS.VENDOR_ENQUIRY_COMPARISION_SAVE, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const VendorEnquiryResponseComparisionDetailsByID = async(payload)=>{
    try {       
        return await callApi(PURCHASE_API_ENDPOINTS.VENDOR_ENQUIRY_COMPARISION_DET_BY_ID, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}

export const EnquiryResponseComparisonApprove = async(payload)=>{
    try {       
        return await callApi(PURCHASE_API_ENDPOINTS.VENDOR_ENQUIRY_COMPARISION_APPROVE, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error(error);
        throw error;
    }
}











